export const ROUTE_PATHS = {
  LOGIN: "/",
  HOME: "/home",
  COMPANY_LIST: "/company/list",
  CATEGORY_LIST: "/category/list",
  INVOICE_LIST: "/invoice/list",
  SUBSCRIPTION_LIST: "/subscription/list",
  ADD_USERS: "users",
  SEARCH_RESULT: "searchResult",
  ADMIN_LOGIN: "/admin/login",
  SIGNUP: "/signup",
  SUBSCRIBE: "/subscribe",
  SECURITY_LIST: "/security/list",
  TWO_FA: "/2fa-login",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  REPORTING: "/reporting",
  TERMS_OF_SERVICE: "/terms-of-service"
};
